// Copyright (c) 2016 Deere & Company

import KeyValuePairCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const resetSpaTypes = () => getClaimDefaultState().spaTypes;

const updateSpaTypes = (state, action) =>
    KeyValuePairCollection.update(state, {
        $set: action.data.spaTypes
    });

export default (state = getClaimDefaultState().spaTypes, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_SPA]: resetSpaTypes,
        [actions.UPDATE_CLAIM_SPA_TYPES]: updateSpaTypes
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/spa/reducers/spa-types.js